import { isEmpty, isNil } from "lodash";

import {
  APP_VERSION,
  METHOD_POST,
  TOKEN_HEADER,
} from "../../../../../util/Constants";
import { getBaseSupportUrl, handleApiResponse } from "./base";

const ASK_SUPPORT_HELP_ENDPOINT = "/ask-support-help";

export const sendAskSupportHelp = async ({
  headers,
  logout,
  subject,
  message,
  solution,
  country,
  files,
}) => {
  const baseUrl = getBaseSupportUrl();

  const url = `${baseUrl}${ASK_SUPPORT_HELP_ENDPOINT}?subject=${subject}&message=${message}&solution=${solution}&country=${country}&frontVersion=${APP_VERSION}`;

  // Crete form data
  const formData = new FormData();

  // Append files
  if (!isNil(files) && !isEmpty(files)) {
    files.forEach((file) => {
      formData.append(`files`, file);
    });
  }

  const headersAuto = {
    [TOKEN_HEADER]: headers?.[TOKEN_HEADER],
  };

  const response = await fetch(url, {
    method: METHOD_POST,
    headers: headersAuto,
    body: formData,
  });

  return handleApiResponse(response, logout);
};
